import { createRouter, createWebHistory } from 'vue-router';
import home from '../views/home.vue';
import assign from '../views/academic staff/assign.vue';
import assessor from '../views/academic staff/assessor.vue';
import candidate from '../views/academic staff/candidate.vue';
import result from '../views/academic staff/result.vue'

import page404 from '../views/404.vue';

import sectionA from '../views/academic staff/sectiona.vue';
import sectionB from '../views/academic staff/sectionb.vue';
import sectionC from '../views/academic staff/sectionc.vue';
import sectionD from '../views/academic staff/sectiond.vue';
import sectionE from '../views/academic staff/sectione.vue';
import sectionF from '../views/academic staff/sectionf.vue';
import sectionG from '../views/academic staff/sectiong.vue';
import sectionH from '../views/academic staff/sectionh.vue';
import sectionI from '../views/academic staff/sectioni.vue';
import sectionJK from '../views/academic staff/sectionj&k.vue';
import sectionL from '../views/academic staff/sectionl.vue';

import section1 from '../views/nonacademic staff/section1.vue';
import section2 from '../views/nonacademic staff/section2.vue';

import nonacademicAssessorSection1 from '../views/nonacademic staff/nonacademicAssessorSection1.vue';
import nonacademicAssessorSection2 from '../views/nonacademic staff/nonacademicAssessorSection2.vue';
import nonacademicAssessorSection3 from '../views/nonacademic staff/nonacademicAssessorSection3.vue';

import generate from '../views/generate.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: home,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  {
    path: '/assign',
    name: 'assign',
    component: assign
  },
  {
    path: '/assessor',
    name: 'assessor',
    component: assessor
  },
  {
    path: '/candidate/:id',
    name: 'candidate',
    component: candidate
  },
  {
    path: '/result/:id',
    name: 'result',
    component: result
  },
  {
    path: '/sectiona',
    name: 'sectionA',
    component: sectionA
  },
  {
    path: '/sectionb',
    name: 'sectionB',
    component: sectionB
  },
  {
    path: '/sectionc',
    name: 'sectionC',
    component: sectionC
  },
  {
    path: '/sectiond',
    name: 'sectionD',
    component: sectionD
  },
  {
    path: '/sectione',
    name: 'sectionE',
    component: sectionE
  },
  {
    path: '/sectionf',
    name: 'sectionF',
    component: sectionF
  },
  {
    path: '/sectiong',
    name: 'sectionG',
    component: sectionG
  },
  {
    path: '/sectionh',
    name: 'sectionH',
    component: sectionH
  },
  {
    path: '/sectioni',
    name: 'sectionI',
    component: sectionI
  },
  {
    path: '/sectionj&k',
    name: 'sectionJ&K',
    component: sectionJK
  },
  {
    path: '/sectionl',
    name: 'sectionL',
    component: sectionL
  },
  {
    path: '/section1',
    name: 'section1',
    component: section1
  },
  {
    path: '/section2',
    name: 'section2',
    component: section2
  },
  {
    path: '/nonacademicassessorsection1',
    name: 'nonacademicAssessorSection1',
    component: nonacademicAssessorSection1
  },
  {
    path: '/nonacademicassessorsection2/:id',
    name: 'nonacademicAssessorSection2',
    component: nonacademicAssessorSection2
  },
  {
    path: '/nonacademicassessorsection3',
    name: 'nonacademicAssessorSection3',
    component: nonacademicAssessorSection3
  },
  {
    path: '/generate',
    name: 'generate',
    component: generate
  },
  {
    path: '/:catchAll(.*)',
    name: 'page404',
    component: page404
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
